import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { SpacesService } from '@modules/settings/services/spaces.service';
import { of, switchMap } from 'rxjs';
import { rowStatusMark, type RowStatusItem } from './row-status';

@Component({
  selector: 'app-row-status-mark',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `@if (mark()) { <span class="px-2 text-xs" [attr.aria-label]="label()">{{ mark() }}</span> }`,
})
export class RowStatusMarkComponent {
  public readonly row = input.required<RowStatusItem>();
  private readonly spaces = inject(SpacesService);
  private readonly space = toSignal(toObservable(this.row).pipe(switchMap(row => rowStatusMark(row) ? this.spaces.getCurrentSpace() : of(null))));
  protected readonly mark = computed(() => rowStatusMark(this.row()));
  protected readonly label = computed(() => {
    const row = this.row();
    const mark = this.mark();
    const id = row.rowStatus?.review?.reviewerAccountId ?? row.rowStatus?.assignment?.toAccountId;
    const space = this.space();
    const person = space?.id === row.accountId ? space.participants.find((p) => p.id === id) : undefined;
    const name = person?.fullName?.trim() || person?.userName;
    return name ? mark + ' → ' + name : mark === 'Review' ? 'Review requested' : 'Assignment awaiting acceptance';
  });
}
